import { ALL_AVAILABLE_FEATURES } from "../../../entities/my/lib/const/features";

const urlAdmin = process.env.REACT_APP_SERVER_URL_ADMIN

const availableFeatures = ALL_AVAILABLE_FEATURES.map((key, index) => ({
    id: index + 1,
    key,
    category: key.split('.')[0],
    name: key,
    description: `Mock feature: ${key}`,
}))

export const IdmMocks: {[key: string]: any} = {
    [`${urlAdmin}/user`]: {
        user: {
            id: 1,
            user_id: 1,
            full_name: 'Mock Admin',
            role: 'admin',
            role_name: 'Администратор',
        },
        paid_functions: {
            assistant: true,
            finance_by_tgs: true,
            student_archive: true,
            payment_landing: true,
            salary: true,
            change_all_students_payment: true,
            tutor_archive: true,
            tutor_filter_by_tg: true,
            tutor_update: true,
            student_comments: true,
            manual_transaction: true,
            gph: true,
            can_penalize_assistants: true,
            tutor_accrual: true,
            tutor_penalty_bonus: true,
        }
    },
    [`${urlAdmin}/api/v1/idm/staff/:id/available-features`]: {
        features: availableFeatures
    },
    [`${urlAdmin}/api/v1/idm/staff`]: {
        items: [
            {
                user_id: 1,
                full_name: 'Нечепорук Максим Алексеевич',
                email: 'maxim@example.com',
                roles: ['Админ', 'Куратор']
            },
            {
                user_id: 2,
                full_name: 'Калашников Павел Сергеевич',
                email: 'pavel@example.com',
                roles: ['HR']
            },
            {
                user_id: 3,
                full_name: 'Иванова Мария Олеговна',
                email: 'maria@example.com',
                roles: ['Ассистент']
            }
        ],
        total: 3
    },
    [`${urlAdmin}/api/v1/idm/staff/:id`]: {
        staff_member: {
            user_id: 1,
            full_name: 'Нечепорук Максим Алексеевич',
            email: 'maxim@example.com',
            phone: '+7 900 111-22-33',
            tg: 'https://t.me/maxim_jordan',
            is_active: true,
            legacy_admin_id: 7,
            legacy_role_id: 2,
            roles: [
                {role_id: 1, role_name: 'Админ'},
                {role_id: 3, role_name: 'Куратор'}
            ],
            effective_features: [
                {
                    feature_id: 1,
                    feature_key: 'students.manage',
                    feature_name: 'Управление студентами',
                    category: 'students'
                },
                {
                    feature_id: 2,
                    feature_key: 'tutors.schedule.manage',
                    feature_name: 'Управление расписанием',
                    category: 'tutors'
                }
            ]
        }
    },
    [`${urlAdmin}/api/v1/idm/roles`]: {
        roles: [
            {id: 1, code: 'admin', name: 'Админ', hierarchy_level: 100, description: 'Полный доступ по ветке'},
            {id: 2, code: 'hr', name: 'HR', hierarchy_level: 80, description: 'Работа с персоналом'},
            {id: 3, code: 'curator', name: 'Куратор', hierarchy_level: 60, description: 'Сопровождение команды'},
            {id: 4, code: 'assistant', name: 'Ассистент', hierarchy_level: 40, description: 'Операционная поддержка'},
        ]
    },
    [`${urlAdmin}/api/v1/idm/features`]: {
        features: availableFeatures,
        total: availableFeatures.length
    },
    [`${urlAdmin}/api/v1/idm/staff/:id/features`]: {
        featureGrants: availableFeatures.map(feature => ({
            featureId: String(feature.id),
            featureKey: feature.key,
            category: feature.category,
            featureName: feature.name,
            description: feature.description,
            targetUserIds: [],
        })),
        total: String(availableFeatures.length),
    },
    [`${urlAdmin}/api/v1/idm/roles/:id/features`]: {features: availableFeatures, total: availableFeatures.length},
    [`${urlAdmin}/api/v1/idm/roles/:id/features_for_creation`]: {features: availableFeatures, total: availableFeatures.length},
    [`${urlAdmin}/api/v1/idm/staff/:id/roles/assign`]: {},
    [`${urlAdmin}/api/v1/idm/staff/:id/roles/remove`]: {},
    [`${urlAdmin}/api/v1/idm/staff/:id/features/grant`]: {},
    [`${urlAdmin}/api/v1/idm/staff/:id/features/revoke`]: {},
    [`${urlAdmin}/api/v1/idm/roles/:id/features/add`]: {},
    [`${urlAdmin}/api/v1/idm/roles/:id/features/remove`]: {},
    [`${urlAdmin}/api/v1/users/create`]: {
        user_id: 4
    },
    [`${urlAdmin}/api/v1/idm/staff/:id/password/reset`]: {},
    [`${urlAdmin}/api/v1/idm/staff/:id/delete`]: {},
}
